import { render, staticRenderFns } from "./CourseAppBarButtons.vue?vue&type=template&id=1760738c&scoped=true&lang=pug&"
import script from "./CourseAppBarButtons.vue?vue&type=script&lang=js&"
export * from "./CourseAppBarButtons.vue?vue&type=script&lang=js&"
import style0 from "./CourseAppBarButtons.vue?vue&type=style&index=0&id=1760738c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1760738c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
